import { z } from "zod";

export function replaceAllSpaces(string: string | undefined): string {
  return !string ? "" : string.replace(/\s/g, "");
}

export function hyphenLowercase(string: string | undefined): string {
  return !string ? "" : string.replace(/\s/g, "-").toLowerCase();
}

export function stringifyObjectValue(obj: object) {
  return Object.fromEntries(Object.entries(obj).map(([key, val]) => [key, val?.toString()]));
}

export function validateEmail(string: string): boolean {
  return z.email().safeParse(string).success;
}

export function trimLowercase(str: string | undefined): string {
  if (typeof str === "string") return str.split(" ").join("").toLocaleLowerCase();

  return "";
}

export function truncate(str = "", maxLength = 45) {
  if (str?.length > maxLength) {
    return `${str.slice(0, maxLength)}...`;
  }

  return str;
}

export function isValidHexColor(hexColor: string | null | undefined): boolean {
  if (!hexColor) {
    return false;
  }

  const hexRegex = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;
  return hexRegex.test(hexColor);
}

// Windchill-style name filter: `*` matches anything, matching ignores case, and a term with no `*`
// matches anywhere in the name (so "wing" and "*wing*" are the same filter). A linear scan rather
// than a regular expression: the filter is typed by the user, and `*a*a*a*b` as a regex backtracks
// for seconds against a long name. Each literal piece is taken at its earliest position, which is
// the standard `*`-glob match.
export function toWildcardMatcher(pattern: string): (name: string) => boolean {
  const glob = pattern.trim().toLowerCase();
  const parts = (glob.includes("*") ? glob : `*${glob}*`).split("*");
  const head = parts[0];
  const tail = parts[parts.length - 1];
  const middle = parts.slice(1, -1).filter((part) => part !== "");
  return (name) => {
    const text = name.toLowerCase();
    if (!text.startsWith(head)) return false;
    let position = head.length;
    for (const part of middle) {
      const at = text.indexOf(part, position);
      if (at < 0) return false;
      position = at + part.length;
    }
    return text.length - position >= tail.length && text.endsWith(tail);
  };
}
